
import React from 'react';
import { DollarSign, Users, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface KolPriceListEmptyStateProps {
  hasFullAccess: boolean;
  isSearching: boolean;
  searchTerm: string;
}

export function KolPriceListEmptyState({ 
  hasFullAccess, 
  isSearching, 
  searchTerm 
}: KolPriceListEmptyStateProps) {
  if (isSearching) {
    return (
      <Card className="mx-auto max-w-md">
        <CardContent className="flex flex-col items-center justify-center py-8 text-center">
          <AlertCircle className="h-12 w-12 text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold mb-2">No Results Found</h3>
          <p className="text-muted-foreground mb-4">
            No KOLs found matching "{searchTerm}". Try adjusting your search terms.
          </p>
        </CardContent>
      </Card>
    );
  }

  if (!hasFullAccess) {
    return (
      <Card className="mx-auto max-w-md">
        <CardContent className="flex flex-col items-center justify-center py-8 text-center">
          <Users className="h-12 w-12 text-muted-foreground mb-4" />
          <h3 className="text-lg font-semibold mb-2">No Assigned KOLs</h3>
          <p className="text-muted-foreground mb-4">
            You don't have any KOLs assigned with content types and pricing information.
          </p>
          <p className="text-sm text-muted-foreground">
            Contact your administrator to get access to more KOL data.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="mx-auto max-w-md">
      <CardContent className="flex flex-col items-center justify-center py-8 text-center">
        <DollarSign className="h-12 w-12 text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold mb-2">No Price Data Available</h3>
        <p className="text-muted-foreground mb-4">
          No KOLs have content types with pricing information set up yet.
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          Add content types to KOL Dictionary entries to see pricing data here.
        </p>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Refresh Data
        </Button>
      </CardContent>
    </Card>
  );
}
